import moment from 'moment-jalaali';
import { toGregorian } from './utils';

export const isValidPersianAlpha = /^[\u0600-\u06FF\s]+$/;

export const isValidPersianAlphaNum = /^[\u0600-\u06FF0-9\s]+$/;

export const isValidEnglishAlpha = /^[a-zA-Z\s]+$/;

export const isValidNumbers = /^[0-9]+$/;

export const isValidPhone = /^0[1-9]{2}[2-9][0-9]{7}$/;

export const isValidMobile = /^(?:((98)|(\+98)|(0098)|0)(9)\d{9})+$/;

export const isValidPostal = /\b(?!(\d)\1{3})[13-9]{5}[0-9]{5}\b/;

export const isValidTelegramId = /^[a-zA-Z0-9]+(?:_[a-zA-Z0-9]+)*$/;

export const isValidInstagramId =
    /^(?!\.)[a-zA-Z0-9_]+(?:\.[a-zA-Z0-9_]+)*(?<!\.)$/;

export const isValidTwitterId = /^[a-zA-Z0-9_]{4,15}$/;

export const isValidBaleId = /^[a-z0-9_]+$/;

export const isValidSoroushId = /^[a-zA-Z][a-zA-Z0-9._-]*$/;

export const isValidEitaaId = /^[a-zA-Z][a-zA-Z0-9_]*$/;

export const isValidAddress = /^[\u0600-\u06FF0-9\s.,-]+$/;

export const isValidBankCard = /^(?:\d{16})$/;

// for accepting sub domains
export const isValidWebsite =
    /^(?:(https?):\/\/)?(?:www\.)?(?!ww\d*\.)[\w-]+(?:\.[\w-]+)*\.[a-zA-Z]{2,}(?:[/?#][^\s]*)?$/i;

export const isValidNational = (value: string) => {
    if (!/^\d{10}$/.test(value) || /^(.)\1{9}$/.test(value)) {
        return false;
    }

    let sub = 0;
    for (let i = 0; i < 9; i++) {
        sub += Number(value[i]) * (10 - i);
    }

    const control = sub % 11;
    const controlDigit = control < 2 ? control : 11 - control;

    return Number(value[9]) === controlDigit;
};

const prepareDate = (value: any) => {
    const gregorianDate = toGregorian(value);
    const selectedDate = moment(gregorianDate, 'YYYY-MM-DD');
    const today = moment().startOf('day');
    return { selectedDate, today };
};

export const isNotInFuture = (value: any) => {
    if (!value) return false;
    const { selectedDate, today } = prepareDate(value);
    return selectedDate.isSameOrBefore(today);
};

export const isInFuture = (value: any) => {
    if (!value) return false;
    const { selectedDate, today } = prepareDate(value);
    return selectedDate.isSameOrAfter(today);
};

export const isAfterYear1300 = (value: any) => {
    if (!value) return false;

    const gregorianDate = toGregorian(value);
    const selectedDate = moment(gregorianDate, 'YYYY-MM-DD');
    const earliestAllowedDate = moment('1921-03-21', 'YYYY-MM-DD');
    return selectedDate.isSameOrAfter(earliestAllowedDate);
};

export const isOver18YearsOld = (value: any) => {
    if (!value) return false;

    const gregorianDate = toGregorian(value);
    const birthDate = moment(gregorianDate, 'YYYY-MM-DD');
    const eighteenYearsAgo = moment().subtract(18, 'years');

    return birthDate.isBefore(eighteenYearsAgo);
};
